// ClientTabLink.jsx
import React from "react";
import { Link, useHistory, useLocation } from "react-router-dom";

/** A <Link> that forces a remount when you click it twice in a row */
export default function ClientTabLink({ record, children, ...rest }) {
  const history = useHistory();
  const location = useLocation();

  // -------- build destination ----------
  const isClient = record.memberType.toLowerCase() === "client";
  const isSpouse = record.memberType.toLowerCase() === "spouse";

  const pathname = isClient
    ? "/profile"
    : isSpouse
    ? "/partner-profile"
    : "/client-family-member";

  const search = isClient
    ? `?para=${record.id}`
    : `?para=${record.clientId}&fId=${record.familyId}`;

  const to = {
    pathname,
    search,
    state: {
      id: record.clientId,
      familyId: record.familyId,
      clickBy: "clientArea",
      memberId: record.id,
    },
  };
  // --------------------------------------

  const handleClick = (e) => {
    // If we’re *already* on this URL, push a dummy query param
    const current = location.pathname + location.search;
    const next = to.pathname + to.search;

    if (current === next) {
      e.preventDefault(); // stop the normal <Link> behaviour
      history.push({
        ...to,
        // append timestamp so the URL is different => new location.key
        search: (to.search ? to.search + "&" : "?") + "_r=" + Date.now(),
      });
    }
    // otherwise let <Link> do the normal navigation
  };

  return (
    <Link
      to={to}
      onClick={handleClick}
      style={{ textDecoration: "none" }}
      {...rest}
    >
      {record.firstName + " " + record.lastName}
    </Link>
  );
}
